import * as style from './style.css';
import type * as React from 'react';
import { Responsive, UIHeading1, UIHeading2, UIText2 } from '@cian/ui-kit';

interface IHeadingProps {
  title: string;
  subtitle: string;
  description: string;
  url: string;
}

export const Heading = ({ title, url, subtitle, description }: IHeadingProps): React.JSX.Element => {
  return (
    <div className={style['container']}>
      <div className={style['title']}>
        <Responsive desktop>
          <UIHeading1 as="h1">
            Планировки квартир в{' '}
            <a href={url} rel="noreferrer" className={style['link']}>
              {title}
            </a>
          </UIHeading1>
        </Responsive>

        <Responsive phone tablet>
          <UIHeading2 as="h1">
            Планировки квартир в{' '}
            <a href={url} rel="noreferrer" className={style['link']}>
              {title}
            </a>
          </UIHeading2>
        </Responsive>

        <UIText2>{subtitle}</UIText2>
      </div>
      <div className={style['description']}>
        <UIText2 color="current_color">{description}</UIText2>
      </div>
    </div>
  );
};
